import React from 'react';

const About = () => {
    return (
        <div>
            <h2>This is about section</h2>
        </div>
    );
};

export default About;